<template>
    <div id="content">
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link
                            :to="{ name: moduleName }"
                            class="btn btn_back"
                            v-translate>Seznam
                    </router-link>
                </p>
                <h1 v-translate>Přidat zdroj obsahu</h1>
            </div>
            <tabs-wrapper>
                <tabs-list>
                    <tabs-list-item
                            v-for="item in responsiveTabsNew"
                            :key="item.key"
                            :item="item"
                            :activate-class="getActiveTabClass(item.key)"
                            @activate-tab="activateTab">
                    </tabs-list-item>
                </tabs-list>
                <tabs-content v-show="isActiveTab('settings')">
                    <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
                        <div class="left">
                            <h2 v-translate>Výběr operátora</h2>
                        </div>
                        <div class="right">
                            <div class="field_left">
                              <operator-select
                                  v-model="operatorIdComputed"
                                  :options="operatorOptions"
                              >
                              </operator-select>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div class="left">
                            <h2 v-translate>Základní údaje</h2>
                        </div>
                        <div class="right">
                            <div class="field_left">
                                <text-input
                                        id="hostname"
                                        :required="true"
                                        v-model="entity.hostname"
                                        ref="hostnameref"
                                    ><translate class="translate">Hostname</translate>
                                </text-input>
                                <text-input
                                        id="ip"
                                        v-model="entity.ip"
                                        ref="ipref"
                                    ><translate class="translate">IP adresa</translate>
                                </text-input>
                                <checkbox-input
                                        id="virtualsource"
                                        v-model="entity.virtual"
                                ><translate class="translate">Virtuální zdroj</translate>
                                </checkbox-input>
                            </div>
                            <div class="field_right">
                                <select-box
                                        id="utilizationfactor"
                                        v-model="entity.utilization_factor"
                                        :options="utilizationFactorOptions"
                                    ><translate class="translate">Vytížitelnost zdroje</translate>
                                </select-box>
                                <select-box-multi
                                        id="locality"
                                        v-model="entity.locality_ids"
                                        :options="localityOptions"
                                    ><translate class="translate">Lokalita</translate>
                                </select-box-multi>
                            </div>
                            <div class="field_left">
                                <date-picker edit-time
                                        id="allow_video_data_delivery_from"
                                        date-format="d. m. yy"
                                        attrKey="allow_video_data_delivery_from"
                                        v-model="entity.allow_video_data_delivery_from"
                                        @update-date="updateContentSourceDate"
                                ><translate class="translate">Poskytovat obsah od</translate>
                                </date-picker>
                            </div>
                            <div class="field_right">
                                <date-picker edit-time
                                        id="allow_video_data_delivery_to"
                                        date-format="d. m. yy"
                                        attrKey="allow_video_data_delivery_to"
                                        v-model="entity.allow_video_data_delivery_to"
                                        @update-date="updateContentSourceDate"
                                ><translate class="translate">Poskytovat obsah do</translate>
                                </date-picker>
                            </div>
                        </div>
                    </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Backend konfigurace</h2>
                    </div>
                    <div class="right">
                      <div class="field">
                        <JSONTextareaInput
                            v-model="entity.backend_config"
                            rows="15"
                        >
                          <translate class="translate">JSON konfigurace</translate>
                        </JSONTextareaInput>
                      </div>
                    </div>
                  </section>
                    <detail-bottom-buttons
                            section-class="buttons buttons_middle"
                            :show-link="false"
                            :module-name="moduleName"
                            @submit-form="createEntity"
                    ></detail-bottom-buttons>
                </tabs-content>
            </tabs-wrapper>
        </form>
    </div>
</template>

<script>
	import contentSources from "./contentSources"
	import detailActions from "@/components/mixins/detail-actions"
	import TabsWrapper from "@/components/common/tabs/TabsWrapper"
	import TabsList from "@/components/common/tabs/TabsList"
	import TabsListItem from "@/components/common/tabs/TabsListItem"
	import TabsContent from "@/components/common/tabs/TabsContent"
  import JSONTextareaInput from "../../common/JSONTextareaInput";

	export default {
		name: "ContentSourceNew",
		components: {
			TabsContent,
			TabsListItem,
			TabsList,
			TabsWrapper,
      JSONTextareaInput
		},
		mixins: [detailActions, contentSources],
		created(ContentSourceService, OperatorService, ProtocolService, LocalityService) {
			this.entityService = ContentSourceService
			this.protocolService = ProtocolService
			this.localityService = LocalityService

			this.initUtilizationFactorOptions(true)
			this.initLocalityOptions()
				.then(() => {
					this.setDefaultLocality()
				})

			if (this.$_createActionAllowedAllOrOwnAndGlobal) {
				this.operatorService = OperatorService
				this.getOperatorsAndSetIdOperatorToEntity(true)
			}
		},
		methods: {
			setDefaultLocality(newValue = null) {
				this.entity.locality_ids = []
				if (Number(newValue) !== 0) {
					this._.forEach(this.localities, (locality) => {
						if (Number(locality['id_operator']) === Number(newValue) && locality['default'] === true) {
							this.entity.locality_ids = [locality['id']]
						}
					})
				} else {
					this._.forEach(this.localities, (locality) => {
						if (locality['id_operator'] === null && locality['default'] === true) {
							this.entity.locality_ids = [locality['id']]
						}
					})
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/ContentSourceNew.vue